/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext } from 'react';
import { BreadcrumbContext } from '../common/Breadcrumb';

interface Breadcrumb {
  breadcrumb: any;
  setBreadcrumb: any;
  INITIAL_BREADCRUMS: any;
  altContent: any;
  setAltContent: any;
}
export const useBreadcrumb = () => useContext(BreadcrumbContext) as Breadcrumb;
